export default (e) => e?.preventDefault(0)